export function formatRateLimitMessage(error, fallback = 'Too many attempts. Please try again shortly.') {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (status !== 429) return detail || fallback;

  const message = typeof detail === 'string' ? detail : fallback;
  const secMatch = message.match(/(\d+)\s*seconds?/i);
  if (!secMatch) return 'Too many attempts right now. Please wait a moment and try again.';

  const seconds = parseInt(secMatch[1], 10);
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return 'Too many attempts right now. Please wait a moment and try again.';
  }

  if (seconds < 60) return `Too many attempts. Please wait ${seconds} seconds.`;
  const mins = Math.ceil(seconds / 60);
  if (mins === 1) return 'Too many attempts. Please wait about 1 minute.';
  return `Too many attempts. Please wait about ${mins} minutes.`;
}
